(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  (function () {
    class SlideshowHero {
      constructor(root) {
        this.root = root;
        this.pin = root.querySelector('[data-sh-pin]');
        this.stage = root.querySelector('[data-sh-stage]');
        this.track = root.querySelector('[data-sh-track]');
        this.dots = Array.from(root.querySelectorAll('[data-sh-dot]'));
        this.progress = root.querySelector('[data-sh-progress]');
        this.count = parseInt(root.dataset.slideCount, 10) || 1;
        this.active = -1;
        this.keepHeaderTransparent = root.dataset.keepHeaderTransparent === 'true';
        this.headerVisible = false;
        this.snapTimer = null;
        this.onScroll = this.onScroll.bind(this);
        this.update = this.update.bind(this);
        this.snapToNearest = this.snapToNearest.bind(this);

        this.bindDots();
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.update, { passive: true });
        this.update();
        this.syncHeader();
      }

      headerHeight() {
        var v = getComputedStyle(document.documentElement).getPropertyValue('--header-group-height');
        var h = parseInt(v, 10);
        return isNaN(h) ? 0 : h;
      }

      /* Keep the theme header transparent for as long as the slideshow still
         sits under it (i.e. covers the top strip of the viewport). */
      syncHeader() {
        if (!this.keepHeaderTransparent) return;
        var rect = this.root.getBoundingClientRect();
        var threshold = this.headerHeight() || 1;
        var covering = rect.top <= threshold && rect.bottom > threshold;
        if (covering === this.headerVisible) return;
        this.headerVisible = covering;
        document.body.classList.toggle('slideshow-hero--keep-header-transparent', covering);
      }

      bindDots() {
        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => {
            const idx = parseInt(dot.dataset.shDot, 10);
            this.scrollToIndex(idx);
          });
        });
      }

      scrollToIndex(idx) {
        const total = this.ownedRange();
        if (total <= 0 || this.count <= 1) return;
        // Each slide sits at an exact fraction of the owned range.
        const fraction = this.count > 1 ? idx / (this.count - 1) : 0;
        const top = this.pin.offsetTop + fraction * total;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }

      onScroll() {
        // Throttle to one rAF per frame for performance.
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => {
          this.raf = null;
          this.update();
        });

        // Snap-to-nearest after the user stops scrolling (120 ms debounce).
        clearTimeout(this.snapTimer);
        this.snapTimer = setTimeout(this.snapToNearest, 120);
      }

      /* Scroll range the pin "owns" = offsetHeight of pin minus one stage height
         (the extra viewport we added in CSS keeps the last slide visible, so the
         scrollable range is still slides-1 steps of one viewport each). */
      ownedRange() {
        // pin height = (count + 1) * vh  →  owned scroll = count * vh
        return this.stage.offsetHeight * this.count;
      }

      update() {
        this.syncHeader();
        const total = this.ownedRange();
        if (total <= 0 || this.count <= 1) {
          this.setActive(0);
          return;
        }
        const rect = this.pin.getBoundingClientRect();
        const scrolled = Math.min(Math.max(-rect.top, 0), total);

        // progress: 0 on first slide, 1 on last slide.
        const progress = scrolled / total;

        // Each slide owns an equal band of [0..1]. Snap to the nearest one
        // using Math.round so the transition fires exactly once per step.
        const idx = Math.min(
          Math.round(progress * (this.count - 1)),
          this.count - 1
        );
        this.setActive(idx);

        if (this.progress) {
          this.progress.style.width = (progress * 100).toFixed(2) + '%';
        }
      }

      /* After the user pauses, scroll to the exact position for the active
         slide so it is always perfectly centered — eliminates the half-way
         stuck feeling between slides. */
      snapToNearest() {
        const total = this.ownedRange();
        if (total <= 0 || this.count <= 1 || this.active < 0) return;
        const rect = this.pin.getBoundingClientRect();
        const scrolled = -rect.top;
        // Only snap while inside the owned range.
        if (scrolled < 0 || scrolled > total) return;
        this.scrollToIndex(this.active);
      }

      setActive(idx, animate = true) {
        if (idx === this.active) return;
        this.active = idx;
        this.track.style.setProperty('--sh-active', idx);
        this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === idx));
      }
    }

    function init() {
      document.querySelectorAll('[data-slideshow-hero]').forEach((el) => {
        if (el.dataset.shInit) return;
        el.dataset.shInit = 'true';
        new SlideshowHero(el);
      });
    }

    if (document.readyState !== 'loading') {
      init();
    } else {
      document.addEventListener('DOMContentLoaded', init);
    }

    // Re-init when sections are re-rendered in the theme editor.
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
